module.exports = __webpack_public_path__ + "img/close.c84aa3b3.svg";